import type { SVGProps } from "react";
import * as React from "react";

const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 4V3zM8 4V3a1 1 0 0 0-.753.341zm-7 8-.753-.659a1 1 0 0 0 0 1.318zm7 8-.753.659A1 1 0 0 0 8 21zM18.707 9.707a1 1 0 0 0-1.414-1.414zm-7.414 4.586a1 1 0 0 0 1.414 1.414zm1.414-6a1 1 0 1 0-1.414 1.414zm4.586 7.414a1 1 0 0 0 1.414-1.414zM21 3H8v2h13zm-13.753.341-7 8 1.506 1.318 7-8zm-7 9.317 7 8 1.506-1.317-7-8zM8 21h13v-2H8zm13 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 21 19zm2.121-.879A3 3 0 0 0 24 18h-2a1 1 0 0 1-.293.707zM24 18V6h-2v12zm0-12a3 3 0 0 0-.879-2.121l-1.414 1.414A1 1 0 0 1 22 6zm-.879-2.121A3 3 0 0 0 21 3v2a1 1 0 0 1 .707.293zm-5.828 4.414-6 6 1.414 1.414 6-6zm-6 1.414 6 6 1.414-1.414-6-6z"
    />
  </svg>
);
export default SvgDelete;
